import type { Styles } from 'common/types';

export const styles: Styles = {
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: 2,
  },
};
